export const CANVAS_SIZE = 1080;

/** Canvas-space px -> on-screen px.
 *
 *  `canvasSize` is the width of the coordinate space being mapped. It stays
 *  1080 for a full-canvas config; in lifestyle mode the product half is pasted
 *  into the 1080 canvas 1:1 (never scaled), so the scale factor is still
 *  displaySize/1080 and callers pass the full display size. The parameter
 *  exists for callers that genuinely map half-space to a half-width surface.
 */
export function toDisplay(
  canvasPx: number,
  displaySize: number,
  canvasSize: number = CANVAS_SIZE,
): number {
  return canvasPx * (displaySize / canvasSize);
}

export function toCanvas(
  displayPx: number,
  displaySize: number,
  canvasSize: number = CANVAS_SIZE,
): number {
  return Math.round(displayPx * (canvasSize / displaySize));
}
